import { createAsyncAction as createAsyncActionV2 } from 'redux-promise-middleware-actions';
import { getFeatureFlags } from 'Api/featureFlagsService';

export const fetchFeatureFlagsAction = createAsyncActionV2('FETCH_FEATURE_FLAGS', async (context) => {
  const flags = await getFeatureFlags(context);
  return flags;
});
